// Authentication utility functions

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  return !!(token && user);
};

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export type StoredUser = {
  id?: number;
  username?: string;
  email?: string;
  [key: string]: unknown;
};

export const getUser = (): StoredUser | null => {
  try {
    const userData = localStorage.getItem('user');
    return userData ? (JSON.parse(userData) as StoredUser) : null;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

export const logout = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const setAuthData = (token: string, user: StoredUser): void => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};
